export default "__VITE_ASSET__DZchv5ru__"